import ErrorIcon from "@mui/icons-material/Error";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { Component } from "react";
import userService from "../../services/userService";
import FieldLengthLabel from "../commons/FieldLengthLabel";
import { withSnackbar } from "./../../hocs/withSnackbar";
import Fade from "@mui/material/Fade";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 20%)",
  borderRadius: "5px",
  p: "15px 20px",
};

class Contact extends Component {
  state = {
    title: "",
    description: "",
    loading: false,
    error: "",
  };

  submit = () => {
    this.setState({
      loading: true,
      error: "",
    });
    const { title, description } = this.state;
    const { showMessage, onClose } = this.props;
    setTimeout(async () => {
      try {
        const response = await userService.submitContactTicket(
          title,
          description
        );
        this.setState({
          error: "",
          loading: false,
        });
        showMessage("Submitted contact ticket!");
        onClose();
      } catch (err) {
        this.setState({
          error: err?.response?.data?.message
            ? err.response.data.message
            : "An error occurred",
          loading: false,
        });
      }
    }, 500);
  };

  render() {
    const { title, description, loading, error } = this.state;
    const { onClose, open } = this.props;
    return (
      <Modal open={open} onClose={onClose}>
        <Fade in={open}>
          <Box sx={style}>
            <h2
              className="heading"
              style={{
                margin: 0,
              }}
            >
              Contact us
            </h2>
            <h4
              className="heading"
              style={{
                margin: 0,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              We'd love to hear from you!
            </h4>
            <hr
              style={{
                opacity: 0.5,
              }}
            />
            <div>
              <TextField
                placeholder="Summarize the issue"
                label="Ticket subject"
                fullWidth
                value={title}
                style={{
                  marginTop: 10,
                }}
                inputProps={{
                  maxLength: 50,
                }}
                InputProps={{
                  style: {
                    fontFamily: "inherit",
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontFamily: "inherit",
                  },
                }}
                onChange={(event) => {
                  this.setState({
                    title: event.target.value,
                  });
                }}
              />
              <FieldLengthLabel
                length={title.length}
                maxLength={50}
                style={{
                  padding: "0 14px",
                  marginTop: 5,
                }}
              />
              <TextField
                placeholder="Describe the issue. Be specific!"
                label="Description"
                fullWidth
                value={description}
                style={{
                  marginTop: 20,
                }}
                inputProps={{
                  maxLength: 300,
                }}
                InputProps={{
                  style: {
                    fontFamily: "inherit",
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontFamily: "inherit",
                  },
                }}
                multiline
                rows={3}
                onChange={(event) => {
                  this.setState({
                    description: event.target.value,
                  });
                }}
              />
              <FieldLengthLabel
                length={description.length}
                maxLength={300}
                style={{
                  padding: "0 14px",
                  marginTop: 5,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: error ? "space-between" : "flex-end",
                marginTop: 10,
              }}
            >
              {error && (
                <div
                  style={{
                    fontSize: 15,
                    color: "red",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ErrorIcon
                    style={{
                      marginRight: 10,
                    }}
                  />
                  {error}
                </div>
              )}
              <LoadingButton
                onClick={() => this.submit()}
                loading={loading}
                loadingPosition="start"
                variant="contained"
                style={{
                  backgroundColor: "var(--theme-orange)",
                }}
                startIcon={<RocketLaunchIcon />}
              >
                Submit
              </LoadingButton>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  }
}

export default withSnackbar(Contact);
